/**
 * CS: Clip Coupon — one-click discount code application.
 * Uses document-level event delegation (IIFE) — matches live theme pattern.
 * Morph-safe: listener registered once on document, never lost.
 * Works inside <dialog> on iOS Safari/Chrome.
 * Element is a <span role="button"> (not <button>) to avoid iOS Safari's
 * native focus ring which cannot be suppressed via CSS.
 */
(function() {
  if (window.__csClipCouponInit) return;
  window.__csClipCouponInit = true;

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-clip-code]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

    const code = btn.dataset.clipCode;
    if (!code) return;

    const wrapper = btn.closest('[data-cs-clip-coupon]');
    const sectionId = wrapper ? wrapper.dataset.sectionId : null;

    /* Loading state */
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Applying\u2026';

    /* Collect existing discount codes from the hidden stock discount pills */
    const existingCodes = [];
    const pills = document.querySelectorAll('.cart-discount__pill');
    for (const pill of pills) {
      if (pill.dataset && pill.dataset.discountCode) {
        existingCodes.push(pill.dataset.discountCode);
      }
    }
    if (existingCodes.indexOf(code) === -1) {
      existingCodes.push(code);
    }

    const cartUpdateUrl = (typeof Theme !== 'undefined' && Theme.routes)
      ? Theme.routes.cart_update_url
      : '/cart/update.js';

    const body = { discount: existingCodes.join(',') };
    if (sectionId) body.sections = [sectionId];

    try {
      const res = await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.status) {
        btn.textContent = 'Clip Coupon';
        btn.removeAttribute('aria-disabled');
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: null,
          sourceId: 'cs-clip-coupon',
          data: { source: 'cs-clip-coupon', itemCount: data.item_count || 0 }
        }
      }));
    } catch {
      btn.textContent = 'Clip Coupon';
      btn.removeAttribute('aria-disabled');
    }
  });
})();
